import React, { Component } from 'react';
import {
    FormGroup, Form, Input, Label, Button
} from 'reactstrap';

export class YesNoForm extends Component {
    constructor(props) {
        super(props);
        this.onSubmit = props.onSubmit;
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {
            'isDirty': false,
            'yesnovalue': props.yesnovalue,
            'onSubmit': props.onSubmit
        };
    }

    // So this is tricky, since our state is handled by the method above
    // and that's in a promise, we start with null prop values
    // This gets called when we update, and we'll get the newest props values.
    componentDidUpdate() {
        if (this.props.yesnovalue != null
            && this.state.yesnovalue !== this.props.yesnovalue
            && !this.state.isDirty) {
            this.setState({ yesnovalue: this.props.yesnovalue });
        }
    }

    handleChange(e) {
        const { value, name } = e.target;
        const converter = { "true": true, "false": false };
        this.setState({ [name]: converter[value], isDirty: true })
    }

    handleSubmit(e) {
        e.preventDefault();
        const { isDirty, yesnovalue } = this.state;
        // We can only submit when the form is dirty
        if (!isDirty) { return; }
        this.onSubmit(yesnovalue)
            .then(_ => {
                this.setState({ isDirty: false });
            });
    }

    render() {
        const { yesnovalue, isDirty } = this.state;
        return (
            <Form inline={true} onSubmit={this.handleSubmit}>
                <FormGroup className="col-2">
                    <Label check>
                        <Input type="radio" name="yesnovalue" value={true} onChange={this.handleChange} checked={yesnovalue === true} title="Yes radio button" />
                        YES
                    </Label>
                </FormGroup>
                <FormGroup className="col-2">
                    <Label check>
                        <Input type="radio" name="yesnovalue" value={false} onChange={this.handleChange} checked={yesnovalue === false} title="No radio button" />
                        NO
                    </Label>
                </FormGroup>
                <Button color='primary' disabled={!isDirty} className="col-2" title="Button to submit consent change" >Save</Button>
            </Form>
        );
    }
}